import { useEffect } from 'react';

/**
 * Держит высоту приложения равной ВИДИМОЙ области экрана.
 *
 * На телефоне клавиатура занимает часть экрана, но окно при этом свою высоту
 * не меняет. Если верстать от высоты окна, лента сохраняет прежний размер,
 * и её низ — где только что появилось отправленное сообщение — оказывается
 * за границей видимого. Человек отправляет сообщение и не видит его.
 *
 * visualViewport сообщает реальную высоту поверх клавиатуры; записываем её
 * в переменную --app-height, от которой и считается разметка.
 */
export function useVisualViewport(): void {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) {
      // Старый браузер: остаётся 100dvh из стилей
      return;
    }

    const apply = () => {
      // Нулевую высоту не применяем: она приходит, когда окно скрыто или
      // свёрнуто, и схлопнула бы весь интерфейс. В таком случае остаётся
      // запасное значение 100dvh из стилей.
      if (viewport.height <= 0) {
        document.documentElement.style.removeProperty('--app-height');
        return;
      }
      document.documentElement.style.setProperty('--app-height', `${viewport.height}px`);
      // Часть браузеров при открытии клавиатуры ещё и сдвигает страницу вверх.
      // Возвращаем её на место, иначе шапка уезжает за верхний край.
      if (viewport.offsetTop !== 0) {
        window.scrollTo(0, 0);
      }
    };

    apply();
    viewport.addEventListener('resize', apply);
    viewport.addEventListener('scroll', apply);
    return () => {
      viewport.removeEventListener('resize', apply);
      viewport.removeEventListener('scroll', apply);
      document.documentElement.style.removeProperty('--app-height');
    };
  }, []);
}
